/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useState } from 'react';
import {
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  FormControl,
  IconButton
} from '@mui/material';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useDropzone } from 'react-dropzone';
import { ERR_EMAIL_INVALID, LABEL_BTN_CANCEL } from 'src/constants/constant';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { Delete02Icon,AddCircleIcon } from '@hugeicons-pro/core-stroke-rounded';
// @ts-ignore
import Papa from 'papaparse/papaparse.min.js';
import { useSelector } from 'react-redux';
import type { appConfigs, BrandApiResponse, RootState } from '../types/types';
import { addSuppressionList } from 'src/services/suppressionListService';
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import * as EmailValidator from 'email-validator';
import Box from "@mui/material/Box";

interface PropsType {
    onClose: () => void;
    onRefresh: () => void;
}

const urlRegx = /^((http|https):\/\/)?(www.)?(?!.*(http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+(\/)?.([\w\?[a-zA-Z-_%\/@?]+)*([^\/\w\?[a-zA-Z0-9_-]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?(\?.*)?$/gm;

const validationSchema = (type: string) =>
  Yup.object().shape({
    title: Yup.string().required('Please enter the title'),
    type: Yup.string().oneOf(["email", "domain"]).required("Type is required"),
    items: Yup.array()
      .of(
        Yup.object().shape({
          value: Yup.string().when([], {
            is: () => type === "email",
            then: schema => schema.email(ERR_EMAIL_INVALID)
                  .test(
                      'is-valid-email',
                      ERR_EMAIL_INVALID,
                      (value:any) => value === '' || EmailValidator.validate(value),
                  ).required("Please enter the email"),
            otherwise: (schema) =>
              schema
              .required("Please enter the Domain")
                .matches(
                  /^(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/,
                  "invalid domain "
                )
              
          }),
        })
      )
      .min(1, "At least one item is required"),
  });

function AddSuppressionList({onClose, onRefresh}: PropsType): JSX.Element {
  const [fileUploaded, setFileUploaded] = useState<File | null>(null);
  const [fileError, setFileError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [MaxRequestBodySizeData, setMaxRequestBodySizeData] = useState<string>("");

  const { user } = useSelector((state: RootState) => state.auth);
  


  const {
    control,
    setValue,
    handleSubmit,
    watch,
    clearErrors,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: {
      title: '',
      type: 'email',
      items: [{ value: '' }],
    },
    resolver: async (data, context, options) =>
      // @ts-ignore
    yupResolver(validationSchema(data.type))(data, context, options),
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'items',
  });

  const typeValue = watch('type');
useEffect(() => {
    const storedAppConfig = localStorage.getItem("appConfigs");
    if (storedAppConfig !== null && storedAppConfig !== '') {
      try {
        const parsedAppConfig = JSON.parse(storedAppConfig) as appConfigs[];
        const maxRequestBodySize = parsedAppConfig.find(
          (item) => item.configName === "MaxRequestBodySize"
        )?.configValue;
        if (maxRequestBodySize != null) {
          setMaxRequestBodySizeData(maxRequestBodySize);
        }
    
      } catch (error) {
        console.error("Error parsing appConfig data:", error);
      }
    }
  }, []);
  const onDrop = useCallback((acceptedFiles: File[], rejectedFiles: any[]) => {
    // Check if file was rejected due to type
    if (rejectedFiles.length > 0) {
      NotificationManager.error('Please upload a valid CSV file.');
      setFileUploaded(null);
      setFileError(null);
      return;
    }

    if (acceptedFiles.length === 0) {
      NotificationManager.error('Please upload a valid CSV file.');
      return;
    }

    const file = acceptedFiles[0];

    // Additional validation to ensure file is CSV
    if (!file.name.toLowerCase().endsWith('.csv') && file.type !== 'text/csv') {
      NotificationManager.error('Please upload a valid CSV file.');
      setFileUploaded(null);
      setFileError(null);
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      const text = reader.result as string;

      Papa.parse(text, {
        header: false,
        skipEmptyLines: true,
        complete: (results: any) => {
          let values: any = results.data
            .flat()
            .map((v: any) => v?.trim())
            .filter(Boolean);

          // Filter out common header names (case-insensitive)
          const commonHeaders = ['email', 'emails','e-mail', 'email address', 'domain name'];
          values = values.filter((v: any) => {
            const lowerValue = v.toLowerCase().trim();
            return !commonHeaders.includes(lowerValue);
          });
          if (values.length === 0) {
            NotificationManager.error('Minimum one record is required.');
            setFileUploaded(null);
            setFileError(null);
            setValue('items', [{ value: '' }]); // Reset to default
            return;
          }

          const invalids: string[] = [];
          const validItems: { value: string }[] = [];

          if (typeValue === 'email') {
            values.forEach((v: any) => {
              // Use the EmailValidator library for more accurate validation
              if (EmailValidator.validate(v)) {
                validItems.push({ value: v });
              } else {
                invalids.push(v);
              }
            });
          } else if (typeValue === 'domain') {
            const domainRegex = /^(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
            values.forEach((v: any) => {
              if (domainRegex.test(v)) {
                validItems.push({ value: v });
              } else {
                invalids.push(v);
              }
            });
          }

          // Check if there are any valid items
          if (validItems.length === 0) {
            NotificationManager.error(`No valid ${typeValue} found in the file.`);
            setFileUploaded(null);
            setFileError(null);
            setValue('items', [{ value: '' }]); // Reset to default
            return;
          }

          // If there are valid items, upload the file successfully (ignore invalid entries)
          setFileUploaded(file);
          setFileError(null);
          setValue('items', validItems); // ✅ Auto-fill form array with only valid items
          clearErrors('items'); // Clear any existing errors on items
          // Trigger validation to ensure the form state is updated
          void trigger('items');      

          // Optionally notify user if some invalid entries were skipped
          if (invalids.length > 0) {
            console.log(`Skipped ${invalids.length} invalid entries:`, invalids);
          }
        },
        error: () => {
          NotificationManager.error('Please upload a valid CSV file.');
          setFileUploaded(null);
          setFileError(null);
          setValue('items', [{ value: '' }]); // Reset to default
        },
      });
    };

    reader.onerror = () => {
      NotificationManager.error('Failed to upload file.');
      setFileUploaded(null);
      setFileError(null);
    };

    reader.readAsText(file);
  }, [typeValue, setValue, clearErrors, trigger]);



  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { 'text/csv': ['.csv'] },
    maxFiles: 1,
  });

  const onSubmit = (data: any) => {
    setIsLoading(true);
    
    // {  "title": "Test 4 ",  "suppressionType": "email",  "clientId": 1,  "createdBy": 1,  "suppressionItems": [    "test1@gmail.com",    "test2@gmail.com"  ]}
    const suppressionItems: any = [];
    data.items.map((item: any) => {
      suppressionItems.push(item.value)
    })
  const uniqueItems = Array.from(new Set(suppressionItems));
    if (uniqueItems.length !== suppressionItems.length) {
      NotificationManager.error('Please remove duplicate entries.');
      setIsLoading(false);
      return;
    }
    const finalRequest = {
      clientId: user?.clientId ?? 0,
      title: data.title,
      suppressionType: data.type,
      createdBy: user?.id ?? 0,
      suppressionItems: suppressionItems,
    };

    addSuppressionList(finalRequest).then((response: BrandApiResponse) => {
      if (response.status === 200 && response.data.result === 1) {
        NotificationManager.success('Suppression list added successfully');
        onRefresh();
      } else {
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        const error = response.data.messages[0].message || 'Failed to add seed list';
        NotificationManager.error(error);
      }
    }).catch((error) => {
      console.error('Error adding suppression list:', error);
    })
      .finally(() => {
        setIsLoading(false);
      });

  };
  const mbValue = Math.round(parseInt(MaxRequestBodySizeData) / 1024 / 1024);
  return (
    <form onSubmit={(e) => {
      e.preventDefault();
      void handleSubmit(onSubmit)(e);
    }}>
      <div className="relative px-[16px] pt-[10px] pb-[60px]">
        {/* Title */}
        <div className="mb-[30px]">
          <Controller
            name="title"
            control={control}
            render={({ field }) => (
              <>
              <TextField
                {...field}
                fullWidth
                label="Title*"
                placeholder="Title*"
                error={!!errors.title}
              />
               {errors.title && (
                                    <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                        <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                        {errors.title?.message} 
                                    </div>
                                )}
              </>
            )}
          />
        </div>

        {/* Type */}
        <div className="mb-[20px] flex items-center gap-4">
          <FormLabel sx={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: '14px', paddingTop: '12px'}}>Type</FormLabel>
          <Controller
            name="type"
            control={control}
            render={({ field }) => (
              <RadioGroup row {...field}
                onChange={(e: any) => {
                setValue('type', e.target.value);
                setFileUploaded(null); // Reset file when type changes
                setFileError(null); // Reset file error when type changes
                setValue('items', [{ value: '' }]); // Reset items array
                clearErrors('items'); // Clear any previous errors on items
              }}>
                <FormControlLabel
                  sx={{
                    '& .MuiFormControlLabel-label': {
                      color: '#3A3A3A',
                      fontSize: '14px'
                    }
                  }}
                  value="email"
                  control={<Radio />}
                  label="Email"
                />
                <FormControlLabel
                  sx={{
                    '& .MuiFormControlLabel-label': {
                      color: '#3A3A3A',
                      fontSize: '14px'
                    }
                  }}
                  value="domain"
                  control={<Radio />}
                  label="Domain"
                />
              </RadioGroup>
            )}
          />
        </div>

        {/* File Upload */}
        <div className='mb-[20px]'>
           <Box sx={{  marginTop: "10px", mx: "auto" }}>
          {
            fileUploaded ?
              (<div className="dropzone">
                <span className="font-semibold">
                  {fileUploaded.name}
                </span>
                <a
                  href="javascript:void(0)"
                  onClick={() => {
                    setFileUploaded(null)
                    setFileError(null);
                    setValue('items', [{ value: '' }]); // Reset items array
                    clearErrors('items'); // Clear any previous errors on items
                  }}
                  style={{ color: 'red', paddingTop: '10px' }}
                >
                  Remove
                </a>
              </div>) : (
                <div  {...getRootProps({ className: "dropzone" })}>
                  <input {...getInputProps()} />
                  {isDragActive ? (
                    <p>Drop the file here ...</p>
                  ) : (
                    <>
                      <p>
                        <strong className="font-semibold">Drag and drop or</strong>
                        <span style={{ color: "#007bff", cursor: "pointer", fontWeight: "600" }}>
                          {" "}Click here{" "}
                        </span>
                        <strong className="font-semibold">to choose file.</strong>
                      </p>
                        <span
                  style={{
                    display: "block",
                    marginTop: "20px",
                    fontSize: "14px",
                    color: "#3A3A3A",
                  }}
                >
                  { `Max size ${mbValue} MB . `} File format: CSV
                </span>
                <span
                  style={{
                    display: "block",
                    marginTop: "5px",
                    fontSize: "14px",
                    color: "#3A3A3A",
                  }}
                >
                  <a
                    href={typeValue === 'email' ? "/assets/suppression-files/Sample-Email.csv" : "/assets/suppression-files/Sample-Domain.csv"}
                   download={typeValue === 'email' ? "Sample_Email.csv" : "Sample_Domain.csv"}
                    onClick={(e) => e.stopPropagation()}
                    style={{
                      color: "#d6242c",
                      textDecoration: "underline",
                      fontWeight: 600,
                    }}
                  >
                    Download
                  </a>{" "}
                  a sample CSV file
                </span>
                      {/* <span className="block mt-[20px] text-sm text-[#3A3A3A]">
                        Max size {mbValue} MB. File format: CSV
                      </span> */}
                    </>
                  )}
                </div>
              )
          }
        </Box>
        </div>

        {fileError !== null && (
          <p className="text-red-600 font-medium mt-2 whitespace-pre-line">{fileError}</p>
        )}

        {/* Email/Domain Inputs (only if no file is uploaded) */}
        {/* {!fileUploaded && ( */}

<div className="space-y-3">
  {fields.map((item, index) => (
    <div key={item.id} className="flex items-start gap-2">
      {/* Input Field */}
      <div className="flex-1 mb-[20px]">
        <Controller
          name={`items.${index}.value`}
          control={control}
          render={({ field }) => (
            <div className="relative">
              <TextField
                {...field}
                fullWidth
                label={typeValue === 'email' ? `Enter Email*` :  `Enter Domain*`}
                error={!!errors.items?.[index]?.value}
                helperText="" // Remove default helperText
              />
              {errors.items?.[index]?.value && (
                <div className="flex absolute text-primary ml-1 mt-1 pb-1 text-md font-normal">
                  <img 
                    src="/assets/images/attention.svg" 
                    alt="error" 
                    width={12} 
                    height={12} 
                    className="mr-1" 
                  />
                  {errors.items?.[index]?.value?.message}
                </div>
              )}
            </div>
          )}
        />
      </div>

      {/* Action Icons Container - Fixed Width */}
      <div className="flex items-center gap-1 pt-2" style={{ minWidth: '80px' }}>
        {/* Delete Icon - Always visible but disabled for single item */}
        <IconButton 
          onClick={() => remove(index)} 
          color="error" 
          aria-label="remove"
          disabled={fields.length === 1}
          size="small"
        >
          <HugeiconsIcon
            icon={Delete02Icon}
            size={20}
             color="#de3339"
          />
        </IconButton>

        {/* Add Icon - Only on last item */}
        {fields.length === index + 1 ? (
          <IconButton 
            onClick={() => append({ value: '' })}
            size="small"
            aria-label="add"
          >
            <HugeiconsIcon
              icon={AddCircleIcon}
              size={20}
              color="#3a3a3a"
              strokeWidth={0.2}
            />
          </IconButton>
        ) : (
          // Placeholder to maintain consistent spacing
          <div style={{ width: '40px' }} />
        )}
      </div>
    </div>
  ))}
</div>
        {/* )} */}
      </div>

      {/* Footer Buttons */}
      <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
        <div className="w-full relative col-span-3">
          <button type='button' className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#ccc] hover:border-[#D9D9D9] disabled:bg-[#f0f0f0] disabled:text-muted" disabled={isLoading} onClick={onClose}>{LABEL_BTN_CANCEL}</button>
        </div>
        <div className="w-full relative col-span-3">
          <button
            type="submit"
            disabled={isLoading || Object.keys(errors).length > 0}
            className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]"
          >
            {!isLoading ? 'Save' : <span className="loading loading-spinner loading-xs text-white"></span>}
          </button>
        </div>
      </div>
    </form>
  );
}

export default AddSuppressionList;
